export default __webpack_public_path__ + "quick-actions-training-tutorials.a74f5480.svg";